import css from 'styled-jsx/css';

/*language=SCSS*/
const staticStyles = css`
  @import 'src/_mixins/vars';

  .GradientPlusButton {
    cursor: pointer;
    width: 20px;
    height: 20px;
    border-radius: $borderRadius;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    span {
      width: 10px;
      height: 2px;
      transition: $transition;
      &:last-of-type {
        position: absolute;
      }
    }

    &__top {
      top: 5px;
    }
    &__bottom {
      bottom: 5px;
    }
    &__left {
      left: 5px;
    }
    &__right {
      right: 5px;
    }

    &__active {
      span {
        &:last-of-type {
          transform: rotate(90deg);
        }
      }
    }
  }
`;

export default staticStyles;
